import { IPerfil } from "@/interfaces/IPerfil";
import { IPermissao } from "@/interfaces/IPermissao";
import { api } from "@/services/api";
import { useAuth } from "react-oidc-context";

export const usePerfil = () => {
  const { user } = useAuth();

  const getPerfisApi = async () => {
    const { data } = await api.get<IPerfil[]>(`/perfis/todos`, {
      headers: {
        Authorization: `Bearer ${user?.access_token}`,
      },
    });
    return data;
  };

  const getPermissoesByPerfilIdApi = async (perfilId: number) => {
    const { data } = await api.get<IPermissao[]>(
      `/perfis/${perfilId}/permissoes`,
      {
        headers: {
          Authorization: `Bearer ${user?.access_token}`,
        },
      }
    );
    return data;
  };

  const updatePermissoesPerfilApi = async (
    id: number,
    content: { permissoes: IPermissao[] }
  ) => {
    await api.put(`/perfis/${id}/permissoes`, content, {
      headers: {
        Authorization: `Bearer ${user?.access_token}`,
      },
    });
  };

  return {
    updatePermissoesPerfilApi,
    getPerfisApi,
    getPermissoesByPerfilIdApi,
  };
};
